import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useTheme,
} from "@mui/material";
import { Interval } from "../../functions/formatData/types";

interface GranularityProps {
  options: Granularity[];
  selected?: Interval | string;
  label?: string;
  setSelected?: (value: Interval) => void;
  sx?: object;
}
const Granularity: React.FC<GranularityProps> = (props) => {
  const theme = useTheme();
  const {
    options = [],
    selected = { label: "mês", value: "month" },
    setSelected = () => {},
    label = "Frequência",
    sx = {},
  } = props;
  // const [selected, setSelected] = useState("month");
  const styles = {
    selectHistorico: {
      borderRadius: 1.2,
      width: "110px",
      height: "35px",
      ...sx,
    },
  };
  return (
    <FormControl>
      <InputLabel id="selectGr">{label}</InputLabel>
      <Select
        label={label}
        labelId="selectGr"
        id="demo-simple-select"
        value={selected}
        displayEmpty
        onChange={(e) => setSelected(e.target.value as Interval)}
        sx={styles.selectHistorico}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: theme.palette.background.paper,
              borderRadius: "7px",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
            },
          },
        }}
      >
        {options &&
          options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {String(option.label).charAt(0).toUpperCase() +
                String(option.label).slice(1)}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default Granularity;
